module.exports = __webpack_public_path__ + "static/media/loader.77463189.svg";